import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { AuthenticateRequest, AuthenticateResponse, AuthorizeResponse } from '../models/authenticate.model';
import { Observable } from 'rxjs';
import { UserDetails } from '../models/user-details.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  trace='Life-Premium-Payment-Portal';

  constructor(private http: HttpClient, private storageService:StorageService) { }

  policySearch(request:AuthenticateRequest): Observable<AuthenticateResponse> {
    let host_url = environment.hosts.api + environment.endpoints.authenticate;
    return this.http.post<AuthenticateResponse>(`${host_url}`, request, {
      headers: {
       // 'trace':this.trace,
        'Client_id': environment.clientID,
        'Content-Type': 'application/json'
      }
    });
  }

  authorize(assertion:string): Observable<AuthorizeResponse> {
    let host_url = environment.hosts.token + environment.endpoints.token;
    const body = new HttpParams()
                  .set('subject_token', assertion)
                  .set('grant_type', 'urn:ietf:params:oauth:grant-type:token-exchange')
                  .set('subject_token_type', 'urn:ietf:params:oauth:token-type:jwt')
                  .set('scope', 'nwapi openid pci');

    return this.http.post<AuthorizeResponse>(`${host_url}`, body.toString(), {
      headers: {
        //'trace':this.trace,
        'Authorization': 'Basic ' + btoa(environment.clientID + ":"),
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache, no-store'
      }
    });
  }

  getUserDetails(mode:string): Observable<UserDetails> {
    let host_url = environment.hosts.api + environment.endpoints.userDetails + `&mode=${mode}`;

    return this.http.get<UserDetails>(`${host_url}`, {
      headers: {
        'Client_id':environment.clientID,
        'Authorization': this.storageService.getAccessToken(),
        'X-NW-Message-ID': 'life',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store'
      }
    });
  }

}
